// extracted by mini-css-extract-plugin
export default {"loader":"LoadingScreen_loader__xvqzg","spin":"LoadingScreen_spin__DNO4M"};